import { defineComponent as a, inject as r, computed as n, useCssModule as p, openBlock as m, createElementBlock as i, normalizeClass as d } from "vue";
import c from "../../utils/propValidator.mjs";
import u from "../../utils/mapClasses.mjs";
import f from "./styles/CdrSkeletonBone.module.scss.mjs";
import C from "../../../_virtual/_plugin-vue_export-helper.mjs";
const y = a({
  name: "CdrSkeletonBone",
  props: {
    /**
     * Sets the type of content placeholder
     * @demoSelectMultiple false
     * @values default, heading, line, rectangle, square
    */
    type: {
      type: String,
      required: !1,
      default: "default",
      validator: (e) => c(e, ["default", "heading", "line", "rectangle", "square"])
    }
  },
  setup(e) {
    const s = "cdr-skeleton-bone", o = r("motionToggle"), t = n(() => `${s}--${e.type}`), l = n(() => o.value ? `${s}__shimmer` : null);
    return {
      style: p(),
      baseClass: s,
      typeClass: t,
      motionToggle: o,
      motionClass: l,
      mapClasses: u
    };
  }
});
function $(e, s, o, t, l, _) {
  return m(), i("div", {
    class: d(e.mapClasses(e.style, e.baseClass, e.typeClass, e.motionClass))
  }, null, 2);
}
const g = {
  $style: f
}, M = /* @__PURE__ */ C(y, [["render", $], ["__cssModules", g]]);
export {
  M as default
};
